var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfoNote(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 6.5C15 6.77614 15.2239 7 15.5 7H19.7929C20.2383 7 20.4614 6.46143 20.1464 6.14645L15.8536 1.85355C15.5386 1.53857 15 1.76166 15 2.20711V6.5Z",
    fill: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5 8H15.5C14.6716 8 14 7.32843 14 6.5L14 2.5C14 1.67157 13.3284 1 12.5 1L4.5 1C3.67157 1 3 1.67157 3 2.5V21.5C3 22.3284 3.67157 23 4.5 23H19.5C20.3284 23 21 22.3284 21 21.5V9.5C21 8.67157 20.3284 8 19.5 8ZM13.9099 16.77V18.68H10.0899V16.77H11.0399V15.7298V12.9498H10.0899V11.0498H12.9599V15.7298V16.77H13.9099ZM12.9598 8.18018H11.0498V10.0902H12.9598V8.18018Z",
    fill: "#222222"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoNote);
export default __webpack_public_path__ + "static/media/info-note.11811059.svg";
export { ForwardRef as ReactComponent };